<!--suppress ALL -->
<script src="jscolor.js"></script>

<!--    <div *ngFor="let banner of heroBanners.controls; let i=index" [formGroupName]="i" class="card mb-3">-->
<!--      <div class="card-body">-->
<!--      </div>-->
<!--    </div>-->


<form [formGroup]="heroBannerForm" (ngSubmit)="onSubmit()" class="container mt-4">
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item" *ngFor="let banner of heroBanners.controls;let i = index" [formGroupName]="i">
      <a class="nav-link" [class]="i == 0? 'active' : ''" [id]="'header_' + i" data-toggle="tab" [href]="'#pane_' + i" role="tab" [aria-controls]="i + '_tab'" aria-selected="true">Banner {{(i + 1)}}</a>
    </li>
    <li class="nav-item">
      <button type="button" class="btn btn-link" (click)="addHeroBanner()" translate>+ Add Banner</button>
    </li>
  </ul>

  <div formArrayName="heroBanners">
    <!-- Tab panes -->
    <div class="tab-content">
      <div *ngFor="let banner of heroBanners.controls;let i = index" [formGroupName]="i" class="tab-pane" [class]="i == 0? 'active' : ''" [id]="'pane_' + i" role="tabpanel" [aria-labelledby]="i + '_tab'">
        <!-- Content for home tab -->
        <h3 class="py-2">{{'Banner' | translate}} # {{(i + 1)}}</h3>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <app-pintura-image-uploader formControlName="imageUrl" [controlId]="'pintura_' + i" [caption]="'Image URL' | translate"></app-pintura-image-uploader>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="headline-{{i}}" translate>Headline (Arabic)</label>
              <input formControlName="headline_ar" id="headline_ar-{{i}}" class="form-control" placeholder="{{'Headline (Arabic)'| translate}}">
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="headline-{{i}}" translate>Headline (English)</label>
              <input formControlName="headline" id="headline-{{i}}" class="form-control" placeholder="{{'Headline (English)'|translate}}">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="subHeadline_ar-{{i}}" translate>Sub Headline (Arabic)</label>
              <input formControlName="subHeadline_ar" id="subHeadline_ar-{{i}}" class="form-control" placeholder="{{'Sub Headline (Arabic)' | translate}}">
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="subHeadline-{{i}}" translate>Sub Headline (English)</label>
              <input formControlName="subHeadline" id="subHeadline-{{i}}" class="form-control" placeholder="{{'Sub Headline (English)'| translate}}">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="headlineColor-{{i}}" translate>Headline Color</label>
              <div class="input-group">
                <input data-jscolor formControlName="headlineColor" id="headlineColor-{{i}}" class="form-control" placeholder="{{'Headline Color'| translate}}" pattern="^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$">
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="subHeadLineColor-{{i}}" translate>Sub Headline Color</label>
              <input data-jscolor pattern="^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$" formControlName="subHeadLineColor" id="subHeadLineColor-{{i}}" class="form-control" placeholder="{{'Sub Headline Color'| translate}}">
            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="backgroundColor-{{i}}" translate>Background Color</label>
              <input data-jscolor pattern="^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$" formControlName="backgroundColor" id="backgroundColor-{{i}}" class="form-control" placeholder="{{'Banner Background Color'| translate}}">
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-danger" (click)="removeHeroBanner(i)">{{'Remove Banner' |  translate}}</button>
        <!-- End Content for home tab -->
      </div>
    </div>
  </div>
<!--  <button type="button" class="btn btn-primary" (click)="addHeroBanner()">{{'Add Hero Banner' |  translate}}</button>-->
  <!--  <button type="submit" class="btn btn-success">Submit</button>-->
</form>
